import _msp_constants from '@shared/msp/constants.js';
import _msp_api from '@shared/msp/api.js';
import _msp_color from '@shared/msp/colors.tinycolor.js';
import _msp_interfaces from '@shared/msp/interfaces.js';
import _msp_utente from '@src/js/msp/utente.js';
import _calendario from '@shared/mixins/calendario.js'
import { alertSoloAllenatore } from '@src/js/msp/alert.js'
import _ums from '@cached/um.json';
import _formatter from '@shared/msp/formatter.js';
import { schedaSport } from '@shared/msp/configSport.js';
import _sports from '@cached/sport.json';
const MSP = {};
MSP.version = 2;
MSP.utente = _msp_utente;
MSP.alertSoloAllenatore = alertSoloAllenatore;
MSP.number = {}
MSP.date = _calendario;
MSP.number.pad = function (number, size)
{
    let s = String(number);
    while (s.length < (size || 2)) {s = "0" + s;}
    return s;
}

/** Funzione usata quando si vuole intercettare un errore da Promise (catch)*/
MSP.catch = function (error)
{
  // Non fare nulla... SHHHH....
  throw 'Uh-oh! ' + error;


}

MSP.getKeyByValue = function (object, value) {
    return Object.keys(object).find(key => object[key] === value);
}

/** Converte un array o una proprietà di un oggetto in parametri
* @param {array} arr array o object di cui serve la key
* @param {string} paramName nome del parametro
* @param {string} objectKey nome della proprietà
* @return {string} stringa parametri
*/
MSP.array2params = function (arr, paramName, objectKey = null)
{
  let params;
  if (objectKey) {
    params = arr[objectKey].map(function(el, idx) {
      return paramName+'['+objectKey+'][' + idx + ']=' + el;
    }).join('&');
  } else {
    params = arr.map(function(el, idx) {
      return paramName+'[' + idx + ']=' + el;
    }).join('&');
  }
    return params;
}

  MSP.isValidJSON = function (text) {
    if (!text)
    {
    return false;
  }
  return (/^[\],:{}\s]*$/.test((""+text).replace(/\\["\\/bfnrtu]/g, '@').
replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?/g, ']').
replace(/(?:^|:|,)(?:\s*\[)+/g, '')))
}

MSP.isValidJSON2 = function (text) {
  try {
    JSON.parse(text);
    return true;
  } catch (e) {
    return false;
  }
}
MSP.getKeyByValue = function (object, value) {
  return Object.keys(object).find(key => object[key] === value);
}


MSP.timeout = null;


MSP.debouncePromise = function (fn, wait = 0, options = {}) {
  let lastCallAt
  let deferred
  let pendingArgs = []
  return function debounced (...args) {
    const currentWait = getWait(wait)
    const currentTime = new Date().getTime()

    const isCold = !lastCallAt || (currentTime - lastCallAt) > currentWait

    lastCallAt = currentTime

    if (isCold && options.leading) {
      return options.accumulate
        ? Promise.resolve(fn.call(this, [args])).then(result => result[0])
        : Promise.resolve(fn.call(this, ...args))
    }

    if (deferred) {
      clearTimeout(MSP.timeout)
    } else {
      deferred = defer()
    }

    pendingArgs.push(args)
    MSP.timeout = setTimeout(flush.bind(this), currentWait)

    if (options.accumulate) {
      const argsIndex = pendingArgs.length - 1
      return deferred.promise.then(results => results[argsIndex])
    }

    return deferred.promise
  }

  function flush () {

    const thisDeferred = deferred
    clearTimeout(MSP.timeout)
    MSP.timeout = null;

    Promise.resolve(
      options.accumulate
        ? fn.call(this, pendingArgs)
        : fn.apply(this, pendingArgs[pendingArgs.length - 1])
    )
      .then(thisDeferred.resolve, thisDeferred.reject)

    pendingArgs = []
    deferred = null
  }
}

function getWait (wait) {
  return (typeof wait === 'function') ? wait() : wait
}

function defer () {
  const deferred = {}
  deferred.promise = new Promise((resolve, reject) => {
    deferred.resolve = resolve
    deferred.reject = reject
  })
  return deferred
}



MSP.debounce = function (func, wait, immediate = false) {
  // timeout privato di questa istanza di debounce (chiusura), non condiviso su MSP:
  // prima era `MSP.timeout`, un'UNICA variabile globale usata da OGNI chiamata a
  // debounce() in tutta l'app. Ogni chiamata "fresca" a _funzioni.debounce(fn, wait)()
  // (pattern usato es. in Calendario.vue: `_funzioni.debounce(this.getFirstDay, 300)()`
  // a ogni evento di scroll) sovrascriveva lo stesso slot globale, cancellando il timer
  // di QUALSIASI altro debounce in corso altrove nell'app entro la finestra di `wait`,
  // anche completamente scollegato. Risultato osservato: il valore letto da un debounce
  // "vincitore" poteva essere quello di una chiamata precedente e non correlata, invece
  // dell'ultima.
  let timeout;
  const debounced = function() {
    let context = this;
    let args = arguments;
    let later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    let callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
  // Annulla la chiamata in attesa (es. per eseguirla subito in modo sincrono).
  debounced.cancel = function () {
    clearTimeout(timeout);
    timeout = null;
  };
  return debounced;
}

/** funzione sort che sulla base degli elementi modificati secondo la funzione passata come paramtro filter
* @param {any} a qualsiasi elemento da usare nel confronto
* @param {any} b qualsiasi elemento da usare nel confronto
* @param {function} filter funzione che trasforma gli elementi passati come argomenti a, b su cui fare il confronto
* @return {number} numero usato in funzioni di sort (-1: minore, 0: uguale, 1: maggiore)
*/
MSP.sortByFilter = function (a, b, filter) {
  var nameA = filter(a);
  var nameB = filter(b);
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }
  return 0;
};

/** Filtra un oggetto in base alle proprietà fornite in forma di stringhe separate da virgola (csv). Se nessuna proprietà fornita è presente nell'oggetto originale, restitusce un oggetto vuoto.
* @param {object} obj Oggetto da filtrare.
* @param {string} csv_props Elenco di proprietà valide, separate da virgola.
* @return {object} Oggetto con le proprietà elencate in csv_props. Se nessuna proprietà fornita è presente nell'oggetto originale, restitusce un oggetto vuoto.
*/
MSP.filterByProps = function (obj, csv_props/*string*/)
{
  let filtered = {};
  let a_props = csv_props.split(",");
  for(let key in obj) {
    if (a_props.indexOf(key) > -1) {
      filtered[key] = obj[key];
    }
  }
  return filtered;
};

MSP.deepProp = function (obj, commaString) {
    if (!obj) return null;
    const parts = commaString.split('.');
    let target = obj;
    while (parts.length > 1) {
        const part = parts.shift();
        target = target[part] || {};
    }
    let prop = target[parts[0]];
    return prop;
}

/** Trova gli elementi di un array che contengano tutte le parole
* @param {Array} a_items Array di oggetti in cui cercare
* @param {String} s_values Lista di parole separate da spazi
* @param {Array} properties Proprietà dell'oggetto in cui cercare
* @return {Array} Array filtrata
*/
MSP.filter = function (a_items, s_values, properties) {
    if (!a_items) return [];
    let filtered = [...a_items];

    if (!(s_values && s_values !== "")) {
        return filtered;
    } else {
        let a_values = s_values.split(" ");

        a_values.forEach((searchValue)=>{
            searchValue = searchValue.toLowerCase();
            let regExp = new RegExp(searchValue,'g');

            let filter = function (el){
                let a_combProps = [];
                properties.forEach(
                    (property)=>{
                        let string = MSP.deepProp(el, property);
                        if (!(string && string.length)) return;
                        a_combProps.push(string.toLowerCase());
                    }
                );
                let combProps = a_combProps.join(" ");
                return combProps.match(regExp);
            }
            filtered = filtered.filter(filter);

        });
    }
    return filtered;

}

// Helper function to check if an array contains only empty values
MSP.isEmptyArray = (arr) => {
  if (!Array.isArray(arr)) return false;
  if (arr.length === 0) return true;
  
  // Check if all elements are empty (0, null, undefined, empty string)
  return arr.every(item => 
    item === 0 || 
    item === null || 
    item === undefined || 
    item === ''
  );
};

MSP.isEmpty = function (obj) {
  if(Object.prototype.hasOwnProperty.call(obj,"length")) {
    return obj.length === 0;
  }

  for(let key in obj) {
    if(Object.prototype.hasOwnProperty.call(obj,key))
    {
      return false;
    }
  }
  return true;
};

MSP._extends = Object.assign || function (target) { for (let i = 1; i < arguments.length; i++) { let source = arguments[i]; for (let key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

MSP.setProp = function (obj, prop, value)
{
  let newProp = {};
  newProp[prop] = value;
  return Object.assign({}, obj, newProp);
}


MSP.getKey = function (obj, val) {
  for (let key in obj) {
    if (obj[key] === val)
    {
      return key;
    }
  }
  return null;
}

MSP.getPropById = function (arr, id_key, id_value, prop)
{
  id_key = id_key || 'id';
  let obj = arr.find(el=>el[id_key]==id_value);
  if (obj)
  {
    return obj[prop]
  }
  return false;
},

MSP.Arr = function(data) {
  data = data || [];
  var obj = {
    set: function (newData) {
      if(Object.prototype.hasOwnProperty.call(newData,'length'))
      {
        data = newData;
      }
    },
    all: function () {
      return data;
    },
    getBy: function (key, val) {
      var fi = data.find(function(el) {
        return el[key] === val;
      });

      return fi;

    }
  };
  return obj;
}




/**Restitusce un array dei mesi nel range di date fornito, con informazioni del nome, del primo giorno e dell'ultimo giorno
* @param {Date} startDate primo giorno del range
* @param {Date} endDate ultimo giorno del range
* @return {Array} lista dei mesi, nel formato {str, first, last}
*/
MSP.getMonths = function (startDate, endDate)
{
  var resultList = [];
  var monthNameList = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];

  while (startDate <= endDate)
  {
    var stringDate = monthNameList[startDate.getMonth()] + " " + startDate.getFullYear();

    //get first and last day of month
    var firstDay = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
    var lastDay = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);

    resultList.push({
      str:stringDate,
      first:firstDay,
      last:lastDay,
    });
    startDate.setMonth(startDate.getMonth() + 1);
  }

  return resultList;
};


MSP.getMonday = _calendario.getMonday;

MSP.countDays = _calendario.countDays;


/** converte una data usando il separatore come elemento di riconoscimento.
* Se la stringa passata contiene "-", converte da YYYY-MM-DD in DD/MM/YYYY
* Se la stringa passata contiene "/", converte da DD/MM/YYYY in YYYY-MM-DD
* @param {String} date data
* @param {String} to @values ["-","/"] forza l'output nel formato scelto
* @return {String} data convertita
*/
MSP.convertDate = function (date,to) {
  if (!date) { return false; }
  if (date.indexOf(to) !== -1) { return date; }
    let hour;
    let a_date = date.split(" ");
        date = a_date[0];
    if (a_date.length > 1) {
        hour = a_date[1];
    }

  let a = ["-", "/"];
  if (date.indexOf('-') === -1) {
    a.reverse();
  }
  date = date.split(a[0]).reverse().join(a[1]);
    if (!hour) {
        return date;
    } else {
        return date+" "+hour;
    }
}

/** crea una copia di un oggetto
* @param {Object} obj oggetto da clonare
* @return {Object} clone
*/
MSP.clone = function(obj) {
  if (obj === null || typeof (obj) !== 'object' || 'isActiveClone' in obj)
  return obj;
  let temp;
  if (obj instanceof Date)
  {
    temp = new obj.constructor(); //or new Date(obj);
  }
  else
  {
    temp = obj.constructor();
  }

  for (let key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      obj['isActiveClone'] = null;
      temp[key] = MSP.clone(obj[key]);
      delete obj['isActiveClone'];
    }
  }
  return temp;
}


/** Aggoimge un valore alla proprietà di un oggetto.
* Se la proprietà non esiste, la imposta = 0
* @param {Object} obj l'oggetto di riferimnento
* @param {String} key la proprietà dell'oggetto
* @param {Number} val la quantità da aggiungere alla proprietà dell'oggetto
* @return {Object} l'oggetto originale con la proprietà modificata
*/
MSP.sumObjKey = function (obj, key, val) {
  if (!Object.prototype.hasOwnProperty.call(obj,key))
  {
    obj[key] = 0;
  }
  obj[key] += val;
  return obj;
}
MSP.fetchArrKey = function (arr, what, options) {
  if (!arr) {
    return false;
  }
  let id = options.id || 'id';
  let result = options.result || 'desc' ;
  let find = arr.filter((el)=>{
    let has_id = Object.prototype.hasOwnProperty.call(el,id);
    let has_result = Object.prototype.hasOwnProperty.call(el,result);

    if (!(has_id&&has_result)) {
      return false;
    }
    if (typeof options.normalize === 'function') {
      return (options.normalize(el[id]) === options.normalize(what));

    } else {
      return ((el[id]) === (what));
    }

  });

  if (find.length === 0) {
    return false;
  }
  if (find.length > 1) {
    return find[0][result];
  }
  return find[0][result];
}


// ### MATH ###

MSP.normalized = function (val, min_in, max_in, min_out, max_out)
{
  return min_out + (val - min_in)/(max_in - min_in)*(max_out-min_out);

}

MSP.int = function(o) {
  let i = parseInt(o, 10);
  if (isNaN(i)) {
    return 0;
  }
  return i;
}

MSP.toInteger = function (val) {
  let number = val.replace(/[\D|.]/g, '');
  if(isNaN(number)) {
    return 0;
  } else {
    return parseInt(number, 10);
  }
};

MSP.toNumber = function (val) {
  val = ""+val;
  val = val.replace(/[,]/g, '.');
  val = val.replace(/[^\d.]/g, '');
  //elimina doppi punti
  val = val.replace(/\..*/, c => "." + c.replace(/\./g, () => ""))
  return val;
}


/** Arrotonda a `digits` decimali, metà lontano da zero (-1.5 → -2). Accetta stringhe con la virgola; non numerico → 0.
* @deprecated usare MSPFormatter.arrotonda (per una stringa con la virgola, convertirla prima in numero)
*/
MSP.round = function (val, digits = 0) {
  // toNumber toglie anche il segno
  const segno = String(val).trim().startsWith("-") ? -1 : 1;
  return _formatter.arrotonda(segno * MSP.toNumber(val), digits || 0) || 0;
};

/** @deprecated usare MSPFormatter.arrotonda */
MSP.decimal = MSP.round;

// ### STRING ###


/** restituisce una stringa come concatenazione di proprietà e stringhe
* @param {object} item oggetto con proprietà da concatenare
* @param {string} pattern string una stringa con elementi separati da virgole: possono essere proprietà di item o stringhe
* @return {string}
*/
MSP.concat = function (item, pattern) {
  var item_label = '';
  let regExp = new RegExp("\"|'",'g');

  let labels = pattern.split(",");
  labels.map(label=>{
    label = label.trim();
    if (label.match(regExp)) {
      item_label += label.replace(regExp, '');
    }
    else
    {
      item_label += item[label];
    }
  });
  return item_label;
}


// ### MISC ###


MSP.unique = function(id) {
  let newID = +new Date();
  if (typeof id === 'undefined') {
    return newID +1 ;
  }
  const params = id.split("_");
  if (params.length === 1) {
    return MSP.int(id);
  }
  if (params[0] === "not") {
    if (newID === params[1]) {
      return newID + 1;
    }
  }
  return newID;
}

      MSP.textAreaAdjust = function MSPTextAreaAdjust(o,count=0,max=10) {
          count++;
          let br = o.getBoundingClientRect();
          // se l'altezza è nulla, ricalcola la dimensione
          // Limita i tentativi per evitare loop infiniti
          if (!br.height && count<max) {
              setTimeout(()=>{
                  MSPTextAreaAdjust(o, count);
              }, 300);
          } else {
              let om = o.style.marginBottom;
              o.style.marginBottom = br.height+"px";
              o.style.height = "1px";
              o.style.height = (25+o.scrollHeight)+"px";
              o.style.marginBottom = om;
          }
      }





  MSP.setBackground = function (col, a) {
    if (!col) {
      return "";
    }
    var bgc = _msp_color.mix("#ffffff", col, a);

    var style = "backgroundColor: " + bgc + ";";
    return style;
  };
  MSP.setBorder = function (col) {
    if (!col) {
      return "";
    }
    var style = "borderBottomColor: " + col + ";";
    return style;
  };
  MSP.setTextWhite = function (col) {
    if (!col) {
      return "";
    }
    const tc = _msp_color.color(col);
    let textColor;
    if (!tc.isLight()) {
      textColor = "color: #fff;";
    } else {
      textColor = "";
    }
    return textColor;
  };


MSP.normalizeTime = function(zoneValue, conv)
{
  var val = 0;
  if (conv === 'm:s')
  {
    val = MSP.hms2sec(zoneValue);
  } else {
    val = parseInt(zoneValue, 10);
  }
  return val;
};

/** normalizza le zone, in base a diverse sorgenti
*/
MSP.normalizeZone = function(zoneObj, time, dist)
{
  let conv;
  if (dist === 'km')
  {
    conv = 1000;
  } else if (dist === '100mt')
  {
    conv = 100;
  } else {
    conv = parseInt(dist, 10);
  }
  var normalized = {};
  for(let key in zoneObj)
  {
    normalized[key] = MSP.normalizeTime(zoneObj[key], time) / conv;
  }
  return normalized;
},

MSP.getUnits = function (um_id) {
  um_id = MSP.int(um_id);
  let um = MSP.getKey(_msp_constants.UMS, um_id);
  return um && _msp_constants.CONVERSIONI[um] || 1;
}

/** verifica se l'unità di misura è in minuti)
* @param {String|Number} um_id id dell'unità di misura (1:km, 2:mt)
* @return {Boolean}
*/
MSP.isMinutes = function (um_id) {
  return MSP.int(um_id) === _msp_constants.UMS.min;
};


/** verifica se l'unità di misura è in H:M:S)
* @param {String|Number} um_id id dell'unità di misura (1:km, 2:mt, 3:hms)
* @return {Boolean}
*/
MSP.isHms = function (um_id) {
  um_id = MSP.int(um_id);
  return (um_id === _msp_constants.UMS.hms) || (um_id === _msp_constants.UMS.ms);
};

/** verifica se l'unità di misura è in H:M:S)
* @param {String|Number} um_id id dell'unità di misura (1:km, 2:mt, 3:hms)
* @return {Boolean}
*/
MSP.isUmTipoHms = function (um_tipo_id) {
  const values = [1,7];
  return (values.indexOf(um_tipo_id) !== -1);
};

/** verifica se il formato del valore è H:M:S o M:S
* @param {String|Number} value valore
* @return {Boolean}
*/
MSP.isFormatHms = function (value) {
  return (value.indexOf(':') !== -1);
};

/** verifica se l'unità di misura è una distanza (metri o chilometri)
* @param {String|Number} um_id id dell'unità di misura (1:km, 2:mt)
* @return {Number|false}
*/
MSP.isDistance = function (um_id) {
  if (
    MSP.isMeters(um_id) || MSP.isKm(um_id)
  ) {
    return um_id;
  }
  return false;
}
MSP.isTime = function (um_id) {
    let um = _ums.find(el=>{
        const found =( el.id == um_id )
            || ( el.codice == um_id )
            || ( el.descrizione == um_id );
        return found;
    });
    if (!um) return false;

    const values = [
        1,
        7,
    ];
    return values.indexOf(um.um_tipo_id) !== -1;
}

MSP.isMeters = function (um_id) {
  um_id = MSP.int(um_id);
  return  (um_id === _msp_constants.UMS.mt);
}
MSP.isKm = function (um_id) {
  um_id = MSP.int(um_id);
  return  (um_id === _msp_constants.UMS.km);
}


MSP.Passo = function () {
  return {
    value: 0,
    label: ''
  };
}

MSP.UMPasso = function (sport_id) {
  sport_id = MSP.int(sport_id);
  var um = "";
  if (sport_id === _msp_constants.sport_id.nuoto) {
    um = 'min/100mt';
  } else if (sport_id === _msp_constants.sport_id.podismo) {
    um = 'min/km';
  }

  return um;
}

MSP.formatDateYmd = function (date) {
    return _calendario.date2ymd(date);
}
MSP.formatDate = function (timestamp, format) {
  format = format || "DD/MM/YYYY";
    if (!timestamp) { return ""; }
  const date = new Date(timestamp);
  if (isNaN(date.getTime())) { return ""; }
  const tokens = {
    YYYY: date.getFullYear(),
    MM: MSP.number.pad(date.getMonth() + 1),
    DD: MSP.number.pad(date.getDate()),
    HH: MSP.number.pad(date.getHours()),
    mm: MSP.number.pad(date.getMinutes()),
    ss: MSP.number.pad(date.getSeconds()),
  };
  return format.replace(/YYYY|MM|DD|HH|mm|ss/g, (token) => tokens[token]);
}

/** Risultato per descrizione dell'um (es. "min/km"), senza suffisso.
* @deprecated usare MSPFormatter.risultato
*/
MSP.formatRisultato = function (val, um_descrizione) {
    const um = _ums.find(el => el.descrizione == um_descrizione);
    return _formatter.risultato(val, um?.codice, { has_suffix: false, empty_value: "/" });
};

/** Risultato di un test o valore di una zona per codice dell'um (passi salvati in s/m).
* @deprecated usare MSPFormatter.risultato
*/
MSP.formatRisultatoByUm = function (val, um_codice, hasSuffix = true, emptyValue = "/") {
    return _formatter.risultato(val, um_codice, { has_suffix: hasSuffix, empty_value: emptyValue });
};

/** Come formatRisultatoByUm, per id dell'um.
* @deprecated usare MSPFormatter.risultato
*/
MSP.formatRisultatoByUmId = function (val, um_id, unused = 'min/km', hasUm = true) {
    void(unused);
    const um = um_id ? _ums.find(el => el.id == um_id) : null;
    return _formatter.risultato(val, um?.codice, { has_suffix: hasUm, empty_value: "/" });
};

MSP.getDistTime = function (val, factor, isDist) {
  var distance;
  var time;

  if (!factor) {
    if (isDist) {
      distance = val;
      time = 0;
    } else {
      time = val;
      distance = 0;
    }
  } else {
    if (isDist) {
      distance = val;
      time = val * factor;
    } else {
      time = val;
      distance = val / factor;
    }
  }

  return {
    distance: distance,
    time: time
  }
}



/** divide la stringa in base ai caratteri diversi dai numeri: (es validi: hh:mm:ss | mm.ss | ss | hh-mm-ss ).
* Se non ci sono separatori, considera il valore come secondi
* @param {String} time in formato hh:mm:ss
* @return {Number} secondi
*/
MSP.hms2sec = function(time){
  let i = 0;
  let sep = time.match(/\D/);
  if (!sep) {
    return time;
  }
  let HHMMSS=time.split(sep[0]).reverse();
  let secs = HHMMSS.reduce(function (a, b) {
    i ++;
    let res = Number(a) + Number(b) * Math.pow(60, i);
    return res;
  });
  return secs;
}

/** converte secondi in stringa formato H:MM:SS
* Wrapper di MSPFormatter.sec2hms (src/shared/msp/formatter.js): i valori non numerici valgono 0.
* @param {Number} d secondi
* @param {Boolean} isMS minuti totali:secondi (5425 → 90:25)
* @param {Boolean} hasDigits aggiunge i decimi
* @return {String}
* @deprecated usare MSPFormatter.sec2hms
*/
MSP.sec2hms = function (d, isMS = false, hasDigits = false) {
  return _formatter.sec2hms(+d || 0, { format: isMS ? "MS" : "HMS", decimi: hasDigits });
};

/** Riporta una stringa tempo con valori fuori scala al formato canonico (00:99 => 01:39)
* @param {String} value tempo HH:MM:SS o MM:SS
* @param {Boolean} isMS formato solo minuti:secondi
* @return {String} tempo normalizzato, o il valore invariato se vuoto
*/
MSP.normalizeHms = function (value, isMS = false) {
  if (!value) {
    return value;
  }
  return MSP.sec2hms(MSP.hms2sec(String(value)), isMS);
};

/** @deprecated usare MSPFormatter.sec2hms_auto (i valori non numerici qui valgono 0) */
MSP.sec2hms_auto = function (d) {
  return _formatter.sec2hms_auto(+d || 0);
};

/** Durata compatta (1h30'20"). Le ore compaiono solo se > 0, qualunque sia `isMS` (tutti i chiamanti passano isMS = d < 3600).
* @deprecated usare MSPFormatter.sec2hms_compact (i valori non numerici qui valgono 0)
*/
MSP.sec2hms_compact = function (d, isMS = false, hasDigits = false) {
  void(isMS);
  return _formatter.sec2hms_compact(+d || 0, { decimi: hasDigits });
};


MSP.um2um = function (val, id_um1, id_um2) {
  return val * MSP.getUnits(id_um1) / MSP.getUnits(id_um2) || 0;
}

MSP.mt2km = function (val) {
  return MSP.um2um(val, _msp_constants.UMS.mt, _msp_constants.UMS.km);
}

MSP.min2sec = function (val) {
  return MSP.um2um(val, _msp_constants.UMS.min, _msp_constants.UMS.sec);

};



MSP.getPassoKm = function (tempo, distanza) {
    return Math.round((tempo * 1000) / distanza);
}


/** Distanza in metri nell'unità dello sport (chiave `distanza` di src/config/sport/<sport>/scheda.json; default metri).
* Con `visibile: false` (ciclismo) restituisce una stringa vuota. I valori non numerici valgono 0.
*/
MSP.formatMtBySport = function (meters, sport_id) {
  const config = schedaSport(sport_id).distanza ?? {};
  if (config.visibile === false) {
    return "";
  }
  return _formatter.distanza(+meters || 0, config);
};

// ### sport
/** Risolve la differenza tra zone nuoto e zone Z.
* Per il nuoto, usa le zone della distanza 100 mt.
* @param {Object} init_zone
* @param {Number} sport_id
* @return {Object} {zona_codice: valore}
*/
MSP.makeZoneBySport = function (init_zone, sport_id)
{
  return (init_zone&&(sport_id == _msp_constants.sport_id.nuoto)) ? (init_zone.distanze['100'].zone) : init_zone;
}



MSP.isCiclismo = function (sport_id) {
  return +sport_id === +_msp_constants.ID_CICLISMO;
}
MSP.isPodismo = function (sport_id) {
  return +sport_id === +_msp_constants.ID_PODISMO;
}
MSP.isNuoto = function (sport_id) {
  return +sport_id === +_msp_constants.ID_NUOTO;
}
MSP.isPalestra = function (sport_id) {
  return +sport_id === +_msp_constants.ID_PALESTRA;
}
MSP.isSci = function (sport_id) {
  return +sport_id === +_msp_constants.ID_SCI;
}


MSP.findSport = function (id) {
    const sport = _msp_constants.SPORT.find(el=>el.id == id);
    return sport;
}

MSP.hasCalcoli = function (sport_id) {
   const sport = MSP.findSport(sport_id);
    if (!sport) return false;

    return Boolean(sport.has_calcoli);
},


MSP.hasAndature = function (sport_id) {
   const sport = MSP.findSport(sport_id);
    if (!sport) return false;

    return Boolean(sport.has_andature);
},

MSP.hasZone = function (sport_id) {
   const sport = MSP.findSport(sport_id);
    if (!sport) return false;

    return Boolean(sport.has_zone);
},

MSP.hasDistance = function (sport_id) {
   const sport = MSP.findSport(sport_id);
    if (!sport) return false;

    return Boolean(sport.has_distance);
},

MSP.hasTime = function (sport_id) {
   const sport = MSP.findSport(sport_id);
    if (!sport) return false;

    return Boolean(sport.has_time);
},

MSP.hasPasso = function (sport_id) {
   const sport = MSP.findSport(sport_id);
    if (!sport) return false;

    return Boolean(sport.has_passo);
},

MSP.hasKcal = function (sport_id) {
   const sport = MSP.findSport(sport_id);
    if (!sport) return false;

    return Boolean(sport.has_kcal);
},

    MSP.hasKjoule = function (sport_id) {
        return MSP.isCiclismo(sport_id);
    },

MSP.hasGraficoAndature = function ({sport_id, totalone}) {
    if (!(totalone?.grafico)) return false;

    const sport = _sports.find(el=>el.id == sport_id);
    if (!sport) return false;

    return Boolean(sport.has_calcoli);
}

MSP.hasGraficoAndatureSemplice = function (allenamento) {
    void(allenamento);
    console.log("TODO grafico andature semplice");
    return false;
}

/** Dato il valore dell'andatura e la sua unità di misura, ricava i metri e i secondi sulla base delle zone di riferimento.
* Essendo tutte le distanze in metri e tutti i tempi in secondi, non convertire.
* @param {Object} andatura
* @param {Array} zone
* @param {Number} ripetute
* @return {Object} {mt: Number, sec: Number}
*
*/
MSP.convertiMtSecAndatura = function (andatura, zone) {
    let media;
    let conv_um = (MSP.isDistance(andatura.um_id)) ? _msp_constants.UMS.mt : _msp_constants.UMS.sec;
    let val = MSP.um2um(andatura.val_andatura, andatura.um_id, conv_um);
    let valori;
    if (zone && zone.length) {
        let zona = zone.find(el=>(
            (+el.id==+andatura.andatura_zona_id)
            && (!el.distanza || el.distanza=="100")
        ));
        if (zona) {
            // andatura_zona_range_da/_a possono mancare su andature più vecchie (salvate
            // prima dell'introduzione dei sotto-range, o create per vie che non passano da
            // MspAndatura.vue/setDefaultZonaRange): senza default, la divisione per un
            // undefined produce NaN, che poi fa fallire silenziosamente tutto il calcolo
            // (bug: distanza sempre 0 nonostante zona/media valide). "Zona intera" (0-100)
            // è lo stesso default usato altrove per andatura_zona_range non impostato.
            let range_da = (andatura.andatura_zona_range_da != null) ? andatura.andatura_zona_range_da : 0;
            let range_a = (andatura.andatura_zona_range_a != null) ? andatura.andatura_zona_range_a : 100;
            let norm = zona.a - zona.da;
            let  da = zona.da + norm * range_da/100;
            let  a = zona.da + norm * range_a/100;
            media = (da + a) / 2;

            valori = MSP.getDistTime(val, media, MSP.isDistance(andatura.um_id));

        } else {
            media = 0;
        }
    } else {
        media = 0;
    }
    if (!media) {
            if (MSP.isDistance(andatura.um_id)) {
                valori = {
                    time: 0,
                    distance: val,
                };
            } else {
                valori = {
                    time: val,
                    distance: 0,
                };
            }
    }

    let totale = Object.assign({}, _msp_interfaces.totale());
    totale.sec = +valori.time;
    totale.mt = +valori.distance;
    return totale;
};

MSP.fillEmpty = function (keys) {
    const filled =  keys.reduce((acc,el)=>{
        acc[el] = 0;
        return acc;
    }, {});
    return filled;
}

//Librerie Database


MSP.loadZoneByIdSport = function (sport_id)
{
  return _msp_api.get('zona.php?sport_id='+sport_id,'/api/v2');
};


MSP.loadUms = function (sport_id) {
  let endpoint = 'um.php';
  if (sport_id) {
    endpoint += '?sport_id='+sport_id;
  }
  return _msp_api.get(endpoint, '/api/v2');
}


/* START: TRIMP, METS */
MSP.loadTrimp = function (sport_id) {
  return _msp_api.get('trimp.php?sport_id='+sport_id, '/api/v2');
};


/*CHECK OK*/
MSP.trimpSec = function (trimp, sec) {
    /** Il trimp è calcolato per minuti di attività. */
  return (sec/60) *  trimp;
};

MSP.metsSec = function (mets, sec) {
  return (sec/60/60) *  mets;
};


MSP.calcolaTrimpAndatura = function (andatura, trimps) {
    let trimp = trimps.find(el=>el.zona_id == andatura.andatura_zona_id);
    let media;
    if (trimp) {
        let norm = +trimp.trimp_a - +trimp.trimp_da;
        let  da = +trimp.trimp_da + norm * +andatura.andatura_zona_range_da/100;
        let  a = +trimp.trimp_da + norm * +andatura.andatura_zona_range_a/100;
        media = (da + a) / 2;
    } else {
        media = 0;
    }
    let result = media * andatura.val_andatura / 60;
    return MSP.decimal(result, 2);
}


MSP.sommaTotaleMtSecAndature = function (andature, zone) {
    let totale = {
        mt: 0,
        sec: 0,
    }

    andature.forEach((andatura) => {
            let totAndaturaMtSec = MSP.convertiMtSecAndatura(andatura, zone);
            let sec = totAndaturaMtSec.sec;
            let mt = totAndaturaMtSec.mt;
            totale.sec += sec;
            totale.mt += mt;
        }
    );

    return totale;

};



/** Somma i valori di tutte le proprietà del totale
*/
MSP.concatTotale = function ({accumulator, totale, keys}) {
    // somma le chiavi
    keys.forEach((key)=>{
        if (!accumulator[key]) { accumulator[key] = 0; }
        accumulator[key] += totale[key];
    });

    return accumulator;
}

MSP.mapOldZone = function (zone) {
    const newZone = [];
    for (let k in zone) {
        newZone.push({
            id: k,
            ...zone[k],
        });
    }
    return newZone;
}

MSP.isOldZone = function (zone) {
    return ((typeof zone === 'object') && zone.length === undefined);
}

MSP.concatZone = function ({accumulator, zone, keys}) {
    
    if (!accumulator.zone) {
        accumulator.zone = [];
    }

    const emptyZone = MSP.fillEmpty(keys);

    if (MSP.isOldZone(zone)) {
        zone = MSP.mapOldZone(zone);
    }
    if (!zone) {
        return accumulator;
    }

    zone.forEach((zona)=>{
        const range = zona.range || 0;
        let iZ = accumulator.zone.findIndex(el => el.id === zona.id && (el.range || 0) === range);
        if(iZ === -1) {
            accumulator.zone.push({
                id: zona.id,
                range: range,
                ...emptyZone,
            });
            iZ = accumulator.zone.length - 1;
        }
        keys.forEach((key)=>{
            if (zona[key]) {
                accumulator.zone[iZ][key] += zona[key];
            }
        });
    });
    return accumulator;
}


    /** aggiorna il grafico se esiste
    * @param {Object} params {
    *  'dettagli': [],
    *  'zone': [], le zone del database, con le caratteristiche generali
    *  'zone_attive': [], i valori da...a... delle zone ricavate dal test atleta
    * }
    * @return {Object} gzone
    */
MSP.getZoneGrafico = function ({dettagli, zone, zone_attive}) {
    let totaliZone = [];
    let tot = {mt:0, sec:0};

    if (!zone) return null;

    dettagli && dettagli.forEach((d)=>{
        if (!d.ripetute) {
            d.ripetute = 1;
        }

        d.serie && d.serie.forEach((s)=>{
            s.andature && s.andature.forEach((a)=>{
                let totAndaturaMtSec = MSP.convertiMtSecAndatura(a, zone_attive);
                let iz = totaliZone.findIndex(el=>el.id===a.andatura_zona_id);
                if(iz === -1) {
                    totaliZone.push(
                        {
                            id: a.andatura_zona_id,
                            mt: 0,
                            sec: 0,
                        });
                    iz = totaliZone.length - 1;
                }
                const mt = +totAndaturaMtSec.mt * d.ripetute * s.ripetute;
                const sec = +totAndaturaMtSec.sec * d.ripetute * s.ripetute;
                totaliZone[iz].mt += mt
                totaliZone[iz].sec += sec
                tot.mt += mt;
                tot.sec += sec;
            })
        })
    });

    let backgroundColor = [];
    let gzone = [];

    zone.forEach((el)=>{
        let percentage;
        let label = el.nome_custom; //da t_zone
        let value = {mt: 0, sec: 0};
        backgroundColor = el.colore; //da t_zone
        const totaleZona = totaliZone.find(tz=>tz.id === el.id);
        if (totaleZona) {
            percentage = {
                mt: _formatter.arrotonda(totaleZona.mt * 100 / tot.mt, 2) || 0,
                sec: _formatter.arrotonda(totaleZona.sec * 100 / tot.sec, 2) || 0
            };
            value = {
                mt: totaleZona.mt,
                sec: totaleZona.sec,
            }
        } else {
            percentage = {
                mt: 0,
                sec: 0,
            };
            value = {
                mt: 0,
                sec: 0,
            };
        }
        let zona = {
            id: el.id,
            label: label,
            percentage: percentage,
            backgroundColor: backgroundColor,
            value: value
        };
        gzone.push(zona);
    });
    return gzone;
}

MSP.filterTestsBySportId = function (tests, sport_id) {
    if (!(tests && tests.length)) { return []; }
    let filtered = tests.filter((el)=>(+el.sport_id === +sport_id));
    if (+_msp_constants.ID_NUOTO === +sport_id) {
        filtered = filtered.map(
            (test)=>{
                return {
                    ...test,
                    zone: test.zone.filter((el)=>(el.distanza=="100")),
                }
            });
    }
    filtered.sort((a,b)=>(a.um_tipo_posizione - b.um_tipo_posizione));
    return filtered;
}


// `+valore || 0` trasformerebbe anche i null (nessun dato) in 0, disegnando una discesa a picco
// invece dell'interruzione della linea. Chart.js con null nel dataset lascia un buco di default
// (spanGaps:false) — basta preservare il null.
MSP.toNumOrNull = function (v) {
    return (v === null || v === undefined || v === '' || v === '-') ? null : +v;
}

// Valore "vuoto" per una cella di MspDataTable: usato per spingere sempre le righe senza
// dato in fondo, in qualunque direzione di ordinamento (v. TabellaGare.vue, ElencoAttivita.vue).
MSP.isEmptySortValue = function (v) {
    return v === null || v === undefined || v === '' || v === '-';
}


export { MSP as default };
